import AdminUpdatePasein from "../../components/AdminTreatmentCategory/TreatmentUpdate";

export default function UpdatePasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminUpdatePasein/>
    </div>
  );
}
